module.exports = __webpack_public_path__ + "static/media/DGA-คู่มือการใช้โปรแกรมที่พัฒนาและปรับปรุง-ส่วนกลาง_v2.6a5dfd79.pdf";